import React from "react";
const icon = (
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64 256V160H224V256H64ZM64 320H224V416H64V320ZM288 416V320H448V416H288ZM448 256H288V160H448V256ZM64 32C28.7 32 0 60.7 0 96V416C0 451.3 28.7 480 64 480H448C483.3 480 512 451.3 512 416V96C512 60.7 483.3 32 448 32H64Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
